(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-recommendations"] && !Shopify.designMode) return;
  try {
    class ProductRecommendationsLook extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-look');
            // JD Code
            document.querySelector('.product-recommendations-loader').style.display = 'none';

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    	
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
                let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
                let swiperObject={
                  loop:eval(Element.dataset.loop),
                  slidesPerView: "auto",
                  spaceBetween: 16,
                  freeMode: {
                    enabled: true,
                    momentum: true,
                    momentumRatio: 0.3,
                    momentumVelocityRatio: 0.3,
                  },
                  speed: 1000,
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }


              if (window.innerWidth > 1024) {
              document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function(element) {
                element.addEventListener('click', function(event) {
                  event.preventDefault();
                  var attVal = this.getAttribute('data-id');
                  var productItem = this.closest('.product-item');
                  var innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
                  innerGrids.forEach(function(innerGrid) {
                    if (attVal === innerGrid.getAttribute('data-id')) {
                      innerGrids.forEach(function(g) {
                        g.classList.remove('active');
                      });
                      innerGrid.classList.add('active');
                    }
                  });
                });
              });
              }

          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations-look', ProductRecommendationsLook);
  } catch(e) { console.error(e); }
})();

})();
